/**
 * Course Entity
 * Represents a course in the dashboard
 */
export interface CourseProps {
  id: string;
  slug: string;
  title: string;
  progress: number;
  instructor: string;
  nextClass: string;
  color: string;
  isDraft?: boolean;
}

export class Course {
  private readonly props: CourseProps;

  constructor(props: CourseProps) {
    this.props = props;
  }

  get id(): string {
    return this.props.id;
  }

  get slug(): string {
    return this.props.slug;
  }

  get title(): string {
    return this.props.title;
  }

  get progress(): number {
    return this.props.progress;
  }

  get instructor(): string {
    return this.props.instructor;
  }

  get nextClass(): string {
    return this.props.nextClass;
  }

  get color(): string {
    return this.props.color;
  }

  get isDraft(): boolean {
    return this.props.isDraft ?? false;
  }

  /**
   * Check if course is a draft (hidden from students)
   */
  isDraftCourse(): boolean {
    return this.props.isDraft === true;
  }

  /**
   * Check if course is published (visible to all)
   */
  isPublished(): boolean {
    return !this.isDraftCourse();
  }

  isCompleted(): boolean {
    return this.progress === 100;
  }

  toPlainObject(): CourseProps {
    return { ...this.props };
  }
}
